import { apiCall, createQueryString } from "../imports"

const PREFIX = "article/posts/tags"

export default {

    findTags(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },
}